<template>
  <form @submit.prevent="handleSubmit">
    <b-row class="m-0">
      <template v-if="form_sr.form_repair?.length">
        <b-col
          md="12"
          class="mb-4"
          v-for="(item, index) in form_sr.form_repair"
          :key="index"
        >
          <div class="border p-3 card-sr-information-form">
            <b-row>
              <b-col md="12">
                <h5 class="card-title text-primary">
                  <strong>ITEM SERVICE & REPAIR</strong>
                </h5>
              </b-col>
              <b-col md="12" class="mb-3">
                <label for="equimnet-name"
                  >Equipment Name <span class="text-red">*</span></label
                >
                <v-select
                  :options="optionEquipments"
                  label="equipmentName"
                  class="bg-white"
                  placeholder="Select Equipment Name"
                  v-model="item.maintenance_master_id"
                  @input="(val) => handleChangeName(val, item)"
                  :clearable="false"
                  searchable
                  track-by="maintenance_master_id"
                  :reduce="(itm) => itm.maintenance_master_id"
                >
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      :required="!item.maintenance_master_id"
                      v-bind="attributes"
                      v-on="events"
                    />
                  </template>
                </v-select>
                <b-form-input
                  required
                  v-if="item.maintenance_master_id == 'other'"
                  placeholder="inpiut Other Name"
                  class="bg-white mt-3 rounded-sm"
                  id="work-item"
                  v-model="item.other_name"
                ></b-form-input>
              </b-col>
              <b-col md="3" class="mb-3">
                <label for="work-item"
                  >Work Item <span class="text-red">*</span></label
                >
                <b-form-input
                  required
                  class="bg-white rounded-sm"
                  placeholder="Input Work Item"
                  id="work-item"
                  v-model="item.title"
                ></b-form-input>
              </b-col>
              <b-col md="3" class="mb-3 rounded-sm">
                <label for="type-rm"
                  >Type R & M <span class="text-red">*</span></label
                >
                <b-form-select
                  placeholder="Select Type R & M"
                  class="bg-white rounded-sm"
                  plain
                  name="work_item"
                  id="type-rm"
                  v-model="item.task_type_id"
                  :options="optionsTaskType"
                  required
                >
                </b-form-select>
              </b-col>
              <b-col md="3" class="mb-3">
                <label for="date"
                  >Department <span class="text-red">*</span></label
                >
                <b-form-select
                  placeholder="Select Department"
                  class="bg-white rounded-sm"
                  plain
                  name="department"
                  :options="optionsDepartment"
                  v-model="item.department_id"
                  required
                >
                </b-form-select>
              </b-col>
              <b-col md="3" class="mb-3">
                <label for="repair-section"
                  >Repair Section <span class="text-red">*</span></label
                >
                <b-form-select
                  class="bg-white rounded-sm"
                  plain
                  name="repair-section"
                  required
                  v-model="item.section"
                >
                  <b-form-select-option :value="null"
                    >-- Seelct Repair Section --</b-form-select-option
                  >
                  <b-form-select-option :value="'DECK'"
                    >Deck</b-form-select-option
                  >
                  <b-form-select-option :value="'ENGINE'"
                    >Engine</b-form-select-option
                  >
                </b-form-select>
              </b-col>
              <b-col md="3" class="mb-3">
                <label for="category"
                  >Category <span class="text-red">*</span></label
                >
                <b-form-select
                  placeholder="Select Category"
                  class="bg-white rounded-sm"
                  v-model="item.category_id"
                  plain
                  name="category"
                  :options="optionsCategory"
                  required
                ></b-form-select>
              </b-col>
              <b-col md="3" class="mb-3">
                <label for="classification"
                  >Classification <span class="text-red">*</span></label
                >
                <b-form-select
                  placeholder="Select Classification"
                  class="bg-white rounded-sm"
                  plain
                  name="classification"
                  :options="optionsClassification"
                  v-model="item.classification_id"
                  @change="handleCountDaysBasedClassification(item)"
                  required
                ></b-form-select>
              </b-col>
              <b-col md="3" class="mb-3">
                <label for="cause">Cuase <span class="text-red">*</span></label>
                <b-form-select
                  placeholder="Select Cuase"
                  class="bg-white rounded-sm"
                  plain
                  name="cause"
                  :options="optionsCause"
                  v-model="item.case_id"
                  required
                ></b-form-select>
              </b-col>
              <b-col md="3" class="mb-3">
                <label for="kind-of-task"
                  >Kind Of Task <span class="text-red">*</span></label
                >
                <b-form-select
                  placeholder="Select Kind Of Task"
                  class="bg-white rounded-sm"
                  plain
                  name="kind-of-task"
                  v-model="item.kind_task_id"
                  :options="optionsKindTask"
                  required
                ></b-form-select>
              </b-col>
              <b-col md="3" class="mb-3">
                <label for="start-date"
                  >Est. Start Date <span class="text-red">*</span></label
                >
                <date-picker
                  placeholder="Select Est. Start Date"
                  id="start-date"
                  v-model="item.start_at"
                  @change="handleCountDaysBasedClassification(item)"
                  class="w-100"
                ></date-picker>
              </b-col>
              <b-col md="3" class="mb-3">
                <label for="finish-date"
                  >Est. Finish Date <span class="text-red">*</span></label
                >
                <date-picker
                  placeholder="Select Est. Finish Date"
                  id="finish-date"
                  @change="calculateDays(item)"
                  v-model="item.estimated_finished_at"
                  class="w-100"
                  :disabled="!item.start_at"
                  :disabled-date="
                    (date) => disableFinishDates(date, item.start_at)
                  "
                ></date-picker>
              </b-col>
              <b-col md="3" class="mb-3">
                <label for="work-location"
                  >Est. Cost Repair Per Item
                  <span class="text-red">*</span></label
                >
                <InputCurrency
                  placeholder="0.00"
                  type="number"
                  required
                  class="bg-white rounded-sm"
                  v-model="item.cost_estimate"
                />
              </b-col>
              <b-col md="3">
                <!-- < /> -->
                <label for="attachment">Item Attachment anjing</label>
                <InputFileMultiple
                  :labelKey="`input-file-sr-item-${index}`"
                  @change-files="(val) => handleInputFilesItem(val, item)"
                  :files="item.filePreview"
                ></InputFileMultiple>
                <div
                  style="max-width: 200px"
                  class="p-0 pr-2 pb-2"
                  v-for="(url, idx) in item.filePreview"
                  :key="`${index}-${idx}`"
                >
                  <AttachmentSR
                    @success-delete="(path) => deleteFile(path, item)"
                    :modelId="item.id"
                    modelName="sr_form_repair"
                    :file="url"
                    @delete="() => handleDeleteFile(item, idx)"
                  />
                </div>
              </b-col>
              <b-col md="12">
                <label for="remark">Item Remarks</label>
                <b-form-textarea
                  id="remark rounded-sm"
                  placeholder="input remarks..."
                  rows="3"
                  class="bg-white"
                  v-model="item.description"
                ></b-form-textarea>
              </b-col>
              <!-- <b-col lg="12" class="mt-3">
                <label class="mb-0">Internal Man Power</label>
                <b-form-checkbox
                  name="check-button"
                  switch
                  v-model="item.is_man_power"
                >
                </b-form-checkbox>
              </b-col> -->
              <!-- <b-col md="12">
                <b-collapse
                  v-model="item.is_man_power"
                  id="collapse_is_man_power"
                >
                  <ListInternalManPower
                    class="mb-3"
                    @onAdd="(value) => onAddManpower(item, value)"
                    @onDelete="(val) => onDeleteManpower(item, val)"
                    :data="item.man_powers"
                    createAble
                  />
                </b-collapse>
              </b-col> -->
              <!-- <b-col lg="12" class="mt-3">
                <label class="mb-0" for="subcon">Sub Contractor</label>
                <b-form-checkbox
                  name="sub-contractor"
                  id="subcon"
                  v-model="item.is_subcon"
                  switch
                >
                </b-form-checkbox>
              </b-col> -->
              <!-- <b-col md="12">
                <b-collapse v-model="item.is_subcon" id="collapse_is_man_power">
                  <ListSubContractor
                    class="mb-3"
                    :data="item.subcons"
                    @addData="(value) => onAddSubcon(item, value)"
                    createAble
                  />
                </b-collapse>
              </b-col> -->
            </b-row>
          </div>
        </b-col>
      </template>
      <b-col class="my-5 d-flex justify-content-end">
        <b-button
          type="button"
          variant="outline-primary"
          class="mr-2"
          @click="$emit('close')"
          >Cancel & Close</b-button
        >
        <b-button
          type="button"
          variant="outline-primary"
          class="mr-2"
          @click="addForm"
          v-if="!multipleSelected.length"
          >Add Form</b-button
        >
        <b-button v-if="!loading" type="submit" variant="primary"
          >Save & Close</b-button
        >
        <b-button v-else type="button" variant="primary">
          <b-spinner small class="mr-2"></b-spinner> Loading...
        </b-button>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { maintenanceActions, srActions, usersActions } from '@/src/Utils/helper'
import AttachmentSR from './AttachmentSR.vue'
import ListInternalManPower from './ListInternalManPower.vue'
import ListSubContractor from './ListSubContractor.vue'
import moment from '@/node_modules/moment/moment'
import LogsApprovalSR from './LogsApprovalSR.vue'
import InputCurrency from '@/src/components/global/InputCurrency.vue'
import InputFileMultiple from '@/src/components/global/InputFileMultiple.vue'

export default {
  name: 'FormItemSR',
  components: {
    ListInternalManPower,
    ListSubContractor,
    AttachmentSR,
    LogsApprovalSR,
    InputCurrency,
    InputFileMultiple,
  },
  props: {
    formId: null,
    selectedItem: null,
    fleetSelected: null,
    headerForm: {
      type: Object,
      default: () => {},
    },
    multipleSelected: {
      type: Array,
      default: () => [],
    },
    optionsTaskType: {
      type: Array,
      default: () => [],
    },
    optionsDepartment: {
      type: Array,
      default: () => [],
    },
    optionsCategory: {
      type: Array,
      default: () => [],
    },
    optionsClassification: {
      type: Array,
      default: () => [],
    },
    optionsCause: {
      type: Array,
      default: () => [],
    },
    optionsKindTask: {
      type: Array,
      default: () => [],
    },
    loading: Boolean,
  },
  data() {
    return {
      optionEquipments: [],
      user_id: JSON.parse(localStorage.getItem('profile')).id,
      form_item: {
        maintenance_id: null,
        maintenance_component_setup_id: null,
        maintenance_component_setup_name: '',
        status_id: null,
        name: '',
        title: null,
        classification_id: null,
        category_id: null,
        department_id: null,
        section: null,
        case_id: null,
        task_type_id: null,
        kind_task_id: null,
        start_at: null,
        actual_finished_at: null,
        description: null,
        estimate_total_days: null,
        cost_estimate: null,
        file: [],
        filePreview: [],
        is_man_power: false,
        is_subcon: false,
        man_powers: [],
        subcons: [],
        estimated_finished_at: null,
      },
      form_sr: {
        accident_at: null,
        location: '',
        site: '',
        pic: '',
        type_of_job: 'custom',
        fleet: '',
        fleet_id: null,
        status: '',
        existed_data: [],
        form_repair: [],
      },
      apiUrl: `${process.env.VUE_APP_API_BASE_URL}/sr/`,
    }
  },
  methods: {
    ...srActions,
    ...maintenanceActions,
    disableFinishDates(date, startDate) {
      if (!startDate) return true // kalau start kosong, disable semua
      return date < new Date(startDate)
    },

    async setJobPerService() {
      try {
        this.loading = true
        const params = {
          user_id: this.user_id,
        }
        let formData = new FormData()
        formData.append('user_id', this.user_id)
        formData.append(
          'user_name',
          JSON.parse(localStorage.getItem('profile')).userDetail.name
        )
        this.form_sr.form_repair.forEach((item, index) => {
          if (item.maintenance_master_id == 'other') {
            item.maintenance_master_id = null
          }
          item.file.forEach((file, fileIndex) => {
            formData.append(`file[${index}]`, file)
          })
          for (const property in item) {
            if (
              !['filePreview', 'man_powers', 'subcons', 'cost_real'].includes(
                property
              )
            ) {
              if (
                property == 'start_at' ||
                property == 'estimated_finished_at'
              ) {
                formData.append(
                  `contents[${index}][${property}]`,
                  moment(item[property]).format('YYYY-MM-DD')
                )
              } else {
                formData.append(
                  `contents[${index}][${property}]`,
                  item[property]
                )
              }
            }
          }
        })
        const res = await this.createJobs({ id: this.formId, formData, params })
        this.$swal(`Berhasil!`, `Create new repair success.`, 'success')
        this.$emit('refetch')
      } catch (error) {
        this.$swal(`Oops!`, `Failed Create Data!!`, 'error')
      }
      this.loading = false
    },
    handleSubmit() {
      if (this.formId) {
        if (this.selectedItem || this.multipleSelected.length) {
          // this.handleUpdateJobs()
          this.$emit('onUpdateSr', this.form_sr.form_repair, 'child')
        } else {
          this.setJobPerService()
        }
      } else {
        this.$emit('save', this.form_sr.form_repair)
      }
    },
    deleteFile(path, item) {
      item.filePreview = item.filePreview.filter((el) => el.path !== path)
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(value)
    },
    addForm() {
      this.form_sr.form_repair.push({ ...this.form_item, filePreview: [] })
    },
    setForm() {
      this.form_sr.form_repair = this.selectedItem
        ? [
            {
              ...this.selectedItem,
              maintenance_master_id:
                this.selectedItem.name == 'Others'
                  ? 'other'
                  : this.selectedItem.maintenance_master_id,
            },
          ]
        : this.multipleSelected
    },
    handleDeleteFile(item, idx) {
      const newFiles = item.filePreview.filter((_, i) => i !== idx)
      const newFileUploads = item.file.filter((_, i) => i !== idx)
      item.filePreview = newFiles
      item.file = newFileUploads
    },
    calculateDays(state) {
      if (state.start_at && state.estimated_finished_at) {
        const start = moment(state.start_at)
        const end = moment(state.estimated_finished_at)
        const diff = end.diff(start, 'days')
        state.estimate_total_days = diff + 1
      } else {
        state.estimate_total_days = 0
      }
    },
    handleCountDaysBasedClassification(state) {
      if (state.start_at && state.classification_id) {
        let days = this.optionsClassification.find(
          (obj) => state.classification_id === obj.value
        )
        const momentDate = moment(state.start_at, 'YYYY-MM-DD')
        const result = momentDate.add(days.interval - 1, 'days')
        state.estimated_finished_at = result.toDate()
        const start = moment(state.start_at)
        const end = moment(state.estimated_finished_at)
        const diff = end.diff(start, 'days')
        state.estimate_total_days = diff + 1
      } else {
        state.estimated_finished_at = null
      }
      this.calculateDays(state)
    },
    handleInputFilesItem(val, item) {
      console.log('anjingg kenapa gak masuk')

      if (!val) return false
      const files = val
      if (files.length) {
        Array.from(files).forEach((file) => {
          item.file.push(file)
          item.filePreview.push({
            url: URL.createObjectURL(file),
            name: file.name,
          })
        })
      }
    },
    onAddManpower(item, manPowers) {
      item.man_powers.push({ ...manPowers })
    },
    onAddSubcon(item, value) {
      console.log('adasdasd', value)
      item.subcons.push(...value)
    },
    onDeleteManpower(item, val) {
      item.man_powers = item.man_powers.filter((el, idx) => idx !== val)
    },
    async fetchMasterEquipment() {
      try {
        const params = {
          page: 1,
          perPage: 99999,
          showAll: true,
        }
        const { data } = await this.getMaintenanceComponent({
          params,
          vehicle_id: this.$route.query?.vehicleId,
        })
        this.optionEquipments = data.map((el) => ({
          ...el,
          equipmentName: el.maintenance_master.equipment_name,
        }))
        this.optionEquipments.push({
          equipmentName: 'Others',
          maintenance_master_id: 'other',
        })
      } catch (error) {
        console.log(error)
      }
    },
    handleChangeName(value, item) {
      const option = this.optionEquipments.find(
        (el) => el.maintenance_master_id == value
      )
      if (value !== 'other') {
        item.maintenance_component_setup_id = option.maintenance_component_id
      } else {
        item.maintenance_component_setup_id = null
        item.maintenance_component_setup_name = ''
      }
      item.name = option.equipmentName
    },
  },
  mounted() {
    // this.addForm()
    if (this.selectedItem || this.multipleSelected?.length) {
      this.setForm()
    } else {
      this.addForm()
    }
    this.fetchMasterEquipment()
  },
}
</script>
<style>
.card-sr-information-form {
  background: #f7f7f7;
  border-radius: 10px;
}

.text-red {
  color: red;
}

.vs__selected-options {
  white-space: nowrap;
  overflow: hidden;
  border: none;
}
</style>
